import React from 'react';
import { Flex, Box, Collapsible } from '@chakra-ui/react';
import Header from '../../sections/header';
import Footer from '../../sections/footer';
import CSCLogo from '../../ui/brandlogos/_blackcsc_logo_cr.png';

export default function ImpactReportLayout(props) {

  return (
    <Flex direction="column" {...props} maxW={'1640px'} mx={'auto'}>
      <Header maxW='{1640px}' />
        { props.reporthero ? 
          (<div className='report-header'>
            {props.reporthero}
          </div>)
          : null
        }
        { props.abovethereport ?
          (<div className='report-above'>
            {props.abovethereport}
          </div>)
          : null
        } 
        <section className='sideBar'>
          <div className='sideBar-container'>
            <div className='sideBar-spacer'></div>
            <div className='sideBar-page'>
              <aside className='sideBar-sidebar'>
                <div className='sideBar-sidebar__logo'>
                  <a href='/corporate-responsibility/impact/2024'>
                    <img src={CSCLogo} alt='' />
                  </a>
                </div>
                <div className='sideBar-sidebar__title'>
                  <span>{props.reportTitle}</span>
                </div>
                <Box className='sideBar-sidebar__nav' display={{ base: 'none', lg: 'block' }}>
                  {props.sidebar}
                </Box>
                <MobileMenu sidebar={props.sidebar} />
              </aside>
              <main className='sideBar-main'>
                {props.mainhero ?
                  (<div className='sideBar-main__hero'>
                    {props.mainhero}
                  </div>)
                  : null
                }
                <div className='sideBar-main__contents'>
                  <article className='sideBar-Main__article'>
                    <header className='sideBar-Main__article-header'>
                      { props.subheading ?
                        (<div className='sideBar-Main__article-subheading'>
                          {props.subheading}
                        </div>)
                        : null
                      }
                      <h1 className='sideBar-Main__article-heading'>
                        {props.heading}
                      </h1>
                    </header>
                    <div id='toc-content' className='sideBar-Main__article-content flow'>
                      {props.children}
                      <div className='container' style={{ marginTop: '4dvh'}}>
                        <p style={{ fontSize: 'var(--step--2)', fontStyle: 'italic', maxW: '100%' }}>Last updated: July 30, 2025</p>
                      </div>
                    </div>
                  </article>
                </div>
              </main>
            </div>
          </div>
        </section>
      <Footer />
    </Flex>
  );
}

const MobileMenu = (props) => {
  return (
    <Box className='sideBar-sidebar__nav'  display={{ base: 'flex', lg: 'none' }}>
      <Collapsible.Root>
        <Collapsible.Trigger 
          paddingBlockStart={'var(--space-xs)'} 
          textTransform={'uppercase'} 
          fontWeight={'bold'}
          color={'gray.600'}
          cursor={'pointer'}
          fontSize={'var(--step--1)'}
        >
          Toggle Navigation
        </Collapsible.Trigger>
        <Collapsible.Content>
          <Box paddingX={'var(--space-s)'} paddingBlockEnd={'var(--space-s)'}>
            {props.sidebar}
          </Box>
        </Collapsible.Content>
      </Collapsible.Root>
    </Box>
  );
};
